import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/images/footer-shape-1.png'
import _imports_1 from '../../assets/images/footer-shape-2.png'
import _imports_2 from '../../assets/images/lapostebjw.png'


const _hoisted_1 = { class: "footer-wrap bg-rock" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Image",
  class: "footer-shape-one"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Image",
  class: "footer-shape-two"
}, null, -1)
const _hoisted_5 = { class: "row pt-100 pb-75" }
const _hoisted_6 = { class: "col-xl-4 col-lg-4 col-md-6 col-sm-6" }
const _hoisted_7 = { class: "footer-widget" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "Image",
  class: "imgheight"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<p class=\"comp-desc\"> Notre mission est de &quot; Satisfaire une clientèle diversifiée et exigeante par la fourniture des services du courrier universel, des services financiers, des prestations de e-commerce...&quot; <br><br> Suivez nous sur nos réseaux sociaux : </p><div class=\"social-link\"><ul class=\"social-profile list-style style1\"><li><a target=\"_blank\" href=\"https://www.facebook.com/laposte.bj\"><i class=\"ri-facebook-fill\"></i></a></li><li><a target=\"_blank\" href=\"https://twitter.com/PosteduBeninSA\"><i class=\"ri-twitter-fill\"></i></a></li><li><a target=\"_blank\" href=\"https://bj.linkedin.com/company/la-poste-du-b%C3%A9nin\"><i class=\"ri-linkedin-fill\"></i></a></li><li><a target=\"_blank\" href=\"https://www.instagram.com/postebenin\"><i class=\"ri-instagram-fill\"></i></a></li></ul></div>", 2)
const _hoisted_11 = { class: "col-xl-3 col-lg-3 col-md-6 col-sm-6" }
const _hoisted_12 = { class: "footer-widget" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h3", { class: "footer-widget-title" }, "Notre entreprise", -1)
const _hoisted_14 = { class: "footer-menu list-style" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-next" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-next" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-next" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-next" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://shake.o2switch.net:2096",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-next" }),
    /*#__PURE__*/_createTextVNode(" Webmail")
  ])
], -1)
const _hoisted_20 = { class: "col-xl-2 col-lg-2 col-md-6 col-sm-6" }
const _hoisted_21 = { class: "footer-widget" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h3", { class: "footer-widget-title" }, "Liens utiles", -1)
const _hoisted_23 = { class: "footer-menu list-style" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-next" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-next" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://bp.laposte.bj",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-next" }),
    /*#__PURE__*/_createTextVNode(" E-boite postale ")
  ])
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-next" }, null, -1)
const _hoisted_28 = { class: "col-xl-3 col-lg-3 col-md-6 col-sm-6" }
const _hoisted_29 = { class: "footer-widget" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h3", { class: "footer-widget-title" }, "Newsletter", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "newsletter-text" }, " Inscrivez-vous à notre newsletter pour recevoir les dernières nouvelles et actualités. ", -1)
const _hoisted_32 = {
  key: 0,
  class: "error-message"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btninscription"
}, " S'inscrire", -1)
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-md-12" }
const _hoisted_36 = { class: "mamention" }
const _hoisted_37 = { class: "copyright-text" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "ri-copyright-line" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "footer-logo"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _hoisted_9
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("ul", _hoisted_14, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/actualite" }, {
                  default: _withCtx(() => [
                    _hoisted_15,
                    _createTextVNode(" Actualités ")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/about" }, {
                  default: _withCtx(() => [
                    _hoisted_16,
                    _createTextVNode(" A propos ")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/services" }, {
                  default: _withCtx(() => [
                    _hoisted_17,
                    _createTextVNode(" Nos services ")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/contact" }, {
                  default: _withCtx(() => [
                    _hoisted_18,
                    _createTextVNode(" Nous contactez ")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_19
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("ul", _hoisted_23, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/faq" }, {
                  default: _withCtx(() => [
                    _hoisted_24,
                    _createTextVNode(" FAQ ")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/contact" }, {
                  default: _withCtx(() => [
                    _hoisted_25,
                    _createTextVNode(" Contact ")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_26,
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/simulation" }, {
                  default: _withCtx(() => [
                    _hoisted_27,
                    _createTextVNode(" Simulation ")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _hoisted_31,
            _createElementVNode("form", {
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => ($options.handleSubmit && $options.handleSubmit(...args)), ["prevent"])),
              class: "newsletter-form"
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "email",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.email) = $event)),
                placeholder: "Votre email",
                class: _normalizeClass({ 'is-invalid': $data.emailError })
              }, null, 2), [
                [_vModelText, $data.email]
              ]),
              ($data.emailError)
                ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString($data.emailError), 1))
                : _createCommentVNode("", true),
              _hoisted_33
            ], 32)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createVNode(_component_router_link, {
              to: "/mentionLegale",
              class: "autredescription"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Mentions légales ")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/donnePersonnelle",
              class: "autredescription"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Données personnelles")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/cookies",
              class: "autredescription"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cookies")
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("p", null, [
        _hoisted_38,
        _createTextVNode(_toDisplayString($data.currentYear) + " LA POSTE DU BENIN SA. Tout droit réservé. ", 1)
      ])
    ])
  ]))
}